/* NP custom 2026-10-23: welcome offer behaviour (sections/np-welcome-offer.liquid).
   Every storage read is guarded: browsers that block site data must never stop this script or the page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-np-offer]');
  if (!root) return;

  var KEYS = { signed: 'np_offer_signed', dismissed: 'np_offer_dismissed', seen: 'np_offer_seen_session', pending: 'np_offer_pending' };
  var DISMISS_DAYS = 30;
  var EXCLUDED_PATHS = /^\/(cart|checkout|checkouts|account|challenge|password|policies)(\/|$)/;
  var OTHER_OVERLAYS = [
    'html.js-drawer-open',
    '.modal--is-active:not(.np-offer)',
    '[id*="orbe" i]', '[class*="orbe" i]',
    '[id*="mdApp" i]', '[class*="mdApp" i]', '[class*="md-app" i]', '[class*="md-modal" i]', '[id*="md-app" i]',
    '[id*="gdpr" i]', '[class*="gdpr" i]',
    '[class*="cookie-banner" i]', '[id*="cookie-banner" i]',
    // NP custom 2026-10-23: Shopify's own cookie banner, in case it replaces the ConversionBear one
    '#shopify-pc__banner', '#shopify-pc__prefs',
    '[role="dialog"][aria-modal="true"]:not([data-np-offer-panel])'
  ];

  var params = new URLSearchParams(window.location.search);
  var preview = params.get('np_offer') === 'preview' || params.get('np_offer') === 'now';
  var previewNow = params.get('np_offer') === 'now'; /* opens at once, ignoring other overlays: for checking the look only */
  var enabled = root.dataset.enabled === 'true';
  var designMode = root.dataset.designMode === 'true';
  var delay = parseInt(root.dataset.delay, 10) || 30;
  var isProduct = /^product/.test(root.dataset.template || '');

  /* The new offer replaces the old np-welcome-popUp: when on (or in preview), stop the old one opening and hide it.
     theme.js only opens the old popup when sessionStorage newsletterAppeared is not set. */
  if (enabled || preview) {
    ssSetEarly('newsletterAppeared', 'true');
    var oldPopup = document.getElementById('shopify-section-np-welcome-popUp');
    if (oldPopup) oldPopup.style.display = 'none';
  }
  function ssSetEarly(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  var panel = root.querySelector('[data-np-offer-panel]');
  var form = root.querySelector('form');
  var input = root.querySelector('#NpOfferEmail');
  var errorEl = root.querySelector('#NpOfferError');
  var submitBtn = form ? form.querySelector('button[type="submit"]') : null;
  var steps = { form: root.querySelector('[data-np-offer-step="form"]'), success: root.querySelector('[data-np-offer-step="success"]') };
  var tab = root.querySelector('[data-np-offer-tab]');
  var tabLabel = root.querySelector('[data-np-offer-tab-label]');
  var successBody = root.querySelector('[data-np-offer-success-body]');
  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var lastFocus = null;
  var opened = false;

  /* ---------- safe storage ---------- */
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function cookieGet(k) {
    try { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; } catch (e) { return null; }
  }
  function cookieSet(k, v, days) {
    try { document.cookie = k + '=' + encodeURIComponent(v) + '; path=/; max-age=' + (days * 86400) + '; SameSite=Lax'; } catch (e) {}
  }
  function isSigned() { return lsGet(KEYS.signed) === '1' || cookieGet(KEYS.signed) === '1'; }
  function markSigned() { lsSet(KEYS.signed, '1'); cookieSet(KEYS.signed, '1', 365); }
  function isDismissed() { return cookieGet(KEYS.dismissed) === '1' || lsGet(KEYS.dismissed) === '1'; }
  function markDismissed() { cookieSet(KEYS.dismissed, '1', DISMISS_DAYS); }

  function track(event) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: event }); } catch (e) {}
  }

  /* ---------- eligibility ---------- */
  function eligible() {
    if (preview) return true;
    if (!enabled || designMode) return false;
    if (EXCLUDED_PATHS.test(window.location.pathname)) return false;
    if (params.get('utm_medium') === 'email') return false;
    return true;
  }

  function otherOverlayVisible() {
    /* Ultimate GDPR cookie banner */
    var cb = document.getElementById('cb-cookie_consent');
    if (cb) {
      var kids = cb.querySelectorAll('*');
      for (var k = 0; k < kids.length; k++) {
        if (kids[k].offsetHeight > 40 && window.getComputedStyle(kids[k]).visibility !== 'hidden') return true;
      }
    }
    for (var i = 0; i < OTHER_OVERLAYS.length; i++) {
      var sel = OTHER_OVERLAYS[i];
      if (sel.indexOf('html.') === 0) {
        if (document.documentElement.matches(sel)) return true;
        continue;
      }
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { continue; }
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (root.contains(n)) continue;
        var cs = window.getComputedStyle(n);
        if ((cs.position === 'fixed' || cs.position === 'absolute') && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05 && n.offsetWidth > 120 && n.offsetHeight > 60) return true;
      }
    }
    return genericOverlayVisible();
  }

  /* Any other large layer pinned to the screen (cookie bars, country pickers, app popups), whatever its name.
     Ignores the header, chat and preview iframes, and anything small. */
  function genericOverlayVisible() {
    var vw = window.innerWidth, vh = window.innerHeight;
    var all = document.body.getElementsByTagName('*');
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      if (n === root || root.contains(n) || n.tagName === 'IFRAME' || n.tagName === 'SCRIPT') continue;
      if (n.closest('#shopify-section-header, .site-header, #PBarNextFrame, [id^="preview-bar"], [id*="PreviewBar" i], [class*="preview-bar" i], .swym-anchor, #NavDrawerSearch')) continue;
      var cs = window.getComputedStyle(n);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) continue;
      var r = n.getBoundingClientRect();
      if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) continue;
      var area = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0)) * Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      /* only real overlays count: at least a fifth of the screen (the Shopify preview bar and sticky bars are smaller) */
      if (area < vw * vh * 0.2) continue;
      /* a full-screen layer that is transparent and lets clicks through is not an overlay */
      if (cs.pointerEvents === 'none') continue;
      var bg = cs.backgroundColor;
      var transparentBg = !bg || bg === 'transparent' || /rgba\([^)]*,\s*0\)$/.test(bg);
      if (transparentBg && !n.firstElementChild) continue;
      if (transparentBg && area >= vw * vh * 0.9) continue;
      return true;
    }
    return false;
  }

  /* ---------- open / close ---------- */
  function setTab(show) {
    if (!tab) return;
    if (isSigned()) { tab.hidden = true; return; }
    tabLabel.textContent = root.dataset.tabLabel || '10% off';
    tab.hidden = !show;
  }

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    if (!opened) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !root.classList.contains('is-modal')) return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(reason) {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    var modal = true; /* centred dialog on every screen size (decided 23 Oct) */
    root.hidden = false;
    root.classList.toggle('is-modal', modal);
    if (modal) {
      panel.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('np-offer-lock');
    } else {
      panel.removeAttribute('aria-modal');
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); });
    });
    if (modal) {
      setTimeout(function () {
        /* on phones don't focus the email field: it would pop the keyboard up before they've read the offer */
        var target = !steps.success.hidden ? root.querySelector('[data-np-offer-success-title]') : (desktopQuery.matches ? input : root.querySelector('.np-offer__close'));
        if (target) target.focus({ preventScroll: true });
      }, 60);
    }
    ssSet(KEYS.seen, '1');
    track('np_offer_view');
    root.dataset.openReason = reason || '';
  }

  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('np-offer-lock');
    if (!isSigned()) markDismissed();
    setTab(true);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- success ---------- */
  function showSuccess(focus) {
    var email = ssGet('np_offer_email');
    if (successBody && email) {
      successBody.textContent = (successBody.getAttribute('data-template-text') || '').replace('[email]', email);
    }
    try { window.sessionStorage.removeItem('np_offer_email'); } catch (e) {}
    steps.form.hidden = true;
    steps.success.hidden = false;
    markSigned();
    if (focus) {
      var t = root.querySelector('[data-np-offer-success-title]');
      if (t) t.focus({ preventScroll: true });
    }
  }

  function setError(msg) {
    errorEl.textContent = msg || '';
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
  }

  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }

  /* Shopify takes over customer-form submits itself (bot protection, sometimes an hCaptcha page), so the sign-up
     always goes through a normal page load. We only validate, note that a sign-up is in progress, and let Shopify
     submit. When the visitor lands back on the site, the card opens on "Check your inbox" (see "came back" below).
     The discount code is never shown on the site: it is only sent by email, which verifies the address. */
  function markPending() { ssSet(KEYS.pending, String(Date.now())); lsSet(KEYS.pending, String(Date.now())); }

  function onSubmit(e) {
    var value = (input.value || '').trim();
    if (!value) { e.preventDefault(); e.stopImmediatePropagation(); setError('Please enter your email address.'); input.focus(); return; }
    if (!validEmail(value)) { e.preventDefault(); e.stopImmediatePropagation(); setError("Please check your email address, it doesn't look quite right."); input.focus(); return; }
    setError('');
    markPending();
    ssSet('np_offer_email', value); /* session only, cleared once shown */
    submitBtn.setAttribute('aria-busy', 'true');
    track('np_offer_submit');
  }

  /* ---------- triggers ---------- */
  var engaged = 0;
  var timer = null;
  function startTimer() {
    timer = setInterval(function () {
      if (document.visibilityState !== 'visible' || otherOverlayVisible()) return;
      engaged += 1;
      if (engaged >= delay) { clearInterval(timer); maybeOpen('timer'); }
    }, 1000);
  }

  function maybeOpen(reason) {
    if (opened) return;
    if (otherOverlayVisible() && !preview) { engaged = delay - 3; startTimer(); return; }
    /* mobile product pages: never cover Add to bag, just show the tab */
    if (!desktopQuery.matches && isProduct && !preview) { setTab(true); return; }
    open(reason);
  }

  function onExitIntent(e) {
    if (e.clientY > 0 || e.relatedTarget || !desktopQuery.matches) return;
    if (ssGet('np_offer_exit') === '1') return;
    ssSet('np_offer_exit', '1');
    if (!otherOverlayVisible()) { clearInterval(timer); open('exit'); }
  }

  /* ---------- wire up ---------- */
  if (form) form.addEventListener('submit', onSubmit, true);
  if (submitBtn) submitBtn.addEventListener('pointerdown', function () { if (validEmail((input.value || '').trim())) markPending(); });
  if (input) input.addEventListener('input', function () { if (errorEl.textContent) setError(''); });
  root.querySelectorAll('[data-np-offer-close]').forEach(function (b) { b.addEventListener('click', close); });
  if (tab) tab.addEventListener('click', function () { open('tab'); });
  document.addEventListener('keydown', onKeydown);

  /* came back from a native submit (fallback or bot check) */
  var pendingAt = parseInt(ssGet(KEYS.pending) || lsGet(KEYS.pending) || '0', 10);
  var cameBack = pendingAt && (Date.now() - pendingAt < 15 * 60 * 1000) &&
    (params.get('customer_posted') === 'true' || /\/(challenge|contact)/.test(document.referrer || ''));
  if (pendingAt && !cameBack && /^\/challenge/.test(window.location.pathname)) { /* on the robot-check page: wait */ return; }
  if (cameBack) {
    try { window.sessionStorage.removeItem(KEYS.pending); } catch (e) {}
    try { window.localStorage.removeItem(KEYS.pending); } catch (e) {}
    showSuccess(false);
    track('np_offer_signup');
    open('posted');
    return;
  }

  if (!eligible()) return;

  root.hidden = false;
  if (isSigned()) { root.hidden = true; return; }
  if (previewNow) { open('preview-now'); return; }
  if (preview) {
    /* behave like the real thing: wait until cookie banner, country popup and drawers are out of the way */
    var waitPreview = setInterval(function () {
      if (!otherOverlayVisible()) { clearInterval(waitPreview); open('preview'); }
    }, 500);
    return;
  }
  if (isDismissed() || ssGet(KEYS.seen) === '1') { if (ssGet(KEYS.seen) === '1') setTab(true); return; }

  startTimer();
  setTimeout(function () { document.addEventListener('mouseout', onExitIntent); }, 5000);
})();
